import { render, staticRenderFns } from "./part-1-global-kra.vue?vue&type=template&id=1863e73e&scoped=true&"
import script from "./part-1-global-kra.vue?vue&type=script&lang=js&"
export * from "./part-1-global-kra.vue?vue&type=script&lang=js&"
import style0 from "./part-1-global-kra.vue?vue&type=style&index=0&id=1863e73e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1863e73e",
  null
  
)

export default component.exports